module.exports = __webpack_public_path__ + "static/media/chef.76f26f0d.svg";